<template>
    <div>       
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>Details de société de livraison  </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end" @click="save = !save">
                <genericBtnComponent v-if="tab == 'option-1' && isDeliveryResult" :ClickFun="putGeneralInformation" svg="1"
                    :Title="$t('configuration.company.save')"
                    :loader="btnloader" />
                 
                <genericBtnComponent v-if="tab == 'option-2' && isDeliveryResult" :ClickFun="navigateToNewBrand" svg="2"
                    :Title="$t('Delivery.DeliveryPerson.create')" />
            
                <genericBtnComponent v-if="tab == 'option-4'&& isDeliveryResult" :ClickFun="navigateToNewVehicle" svg="2"
                    :Title="$t('Delivery.Vehicule.create')"/>
            </div>
        </div>
    </div>
   
    <v-card flat>
        <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
            <v-tab class="slider" value="option-1" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.general') }}</v-tab>
            <v-tab class="slider" value="option-2" :style="NotActive" centered v-model="general">
                {{ $t('Delivery.DeliveryPerson.DeliveryPersons') }}</v-tab>
            <v-tab v-if="!isDeliveryResult" class="slider" value="option-3" :style="NotActive" centered v-model="general">
                    {{ $t('Delivery.Orders') }}</v-tab>
            <v-tab class="slider" value="option-4" :style="NotActive" centered v-model="general">
                {{ $t('Delivery.Vehicules') }}</v-tab>
        </v-tabs>
        
        <v-divider class="ma-0"></v-divider>
        <v-window v-model="tab" :key="tab" :companyId="companyId">
            <v-window-item value="option-1">
                <DeliveryCompanyGeneralInformation ref="generalInformationListRef" :companyId="companyId" :isDeliveryResult="isDeliveryResult"/>
            </v-window-item>
            <v-window-item value="option-2">
                <DelivryPersonsList ref="DocumentsListRef" :companyId="companyId" :isDeliveryResult="isDeliveryResult" />
            </v-window-item>
            <v-window-item value="option-3">
                <DeliveryCompanyOrderList ref="DocumentsListRef" :companyId="companyId" :isDeliveryResult="isDeliveryResult" />
            </v-window-item>
            <v-window-item value="option-4">
                <DeliveryVehiculesList ref="DocumentsListRef" :companyId="companyId" :isDeliveryResult="isDeliveryResult" />
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
import DeliveryCompanyGeneralInformation from './DeliveryCompanyGeneralInformation.vue'
import DelivryPersonsList from './DeliveryPersons/DelivryPersonsList.vue'
import DeliveryVehiculesList from './DeliveryVehicules/DeliveryVehiculesList.vue';
import DeliveryCompanyOrderList from './DeliveryCompanyOrder/DeliveryCompanyOrderList.vue';
import genericBtnComponent from '@/genericComponent/genericBtnComponent.vue';
import { updateDeliveryCompanyInformation, idDelivery , isDelivery } from "@/api/index";

export default {
    name: "ClientsDetails",
    components: {
        DeliveryCompanyGeneralInformation,
        genericBtnComponent,
        DelivryPersonsList,
        DeliveryVehiculesList,
        DeliveryCompanyOrderList
    },
    data: () => ({
        tab: "option-1",
        general: true,
        step: 1,
        NotActive: {
            color: "#667280",
            fontSize: "14px",
            font: "inter",
        },
        canEditGeneralInformation: false,
        isDisabled: {
            type: Boolean,
            default: false
        },
        companyId: null,
        isDeliveryResult: false,
    }),
    created() {
        if (this.$route.params.id){
            this.companyId = this.$route.params.id;
        } else {
            this.companyId = idDelivery();
        }
        this.checkIsDelivery()
    },
    methods: {
        checkIsDelivery() {
            this.isDeliveryResult = this.isDelivery();
        },
        isDelivery(){
            return isDelivery();
        },
        async putGeneralInformation() {
            this.btnloader = true;
            try {
                const formData = new FormData();
                formData.append('companyName', this.$refs.generalInformationListRef.companyData.name);
                formData.append('companyDescription', this.$refs.generalInformationListRef.companyData.description);
                formData.append('EmailAddress', this.$refs.generalInformationListRef.companyData.email);
                formData.append('Phone', this.$refs.generalInformationListRef.companyData.phone);
                formData.append('Address', this.$refs.generalInformationListRef.companyData.address);
                formData.append('TaxIdentificationNumber', this.$refs.generalInformationListRef.companyData.taxIdentificationNumber);

                if (this.$refs.generalInformationListRef.companyData.companyLogo) {
                    formData.append('companyLogo', this.$refs.generalInformationListRef.companyData.companyLogo);
                }

                if (this.$refs.generalInformationListRef.companyData.patent) {
                    formData.append('patent', this.$refs.generalInformationListRef.companyData.patent);
                }

                await updateDeliveryCompanyInformation(this.companyId, formData);

                this.$emit("snackbarSuccess", this.$t("Delivery.companyUpdated"));
            } catch (error) {
                console.error("Error updating delivery company:", error);
                this.$emit("snackbarError", this.$t("Delivery.updateFailed"));
            } finally {
                this.btnloader = false;
            }
        },

        navigateToNewBrand() {
            this.$router.push({ path: '/NewDeliveryPerson', query: { deliveryCompanyId: this.companyId } });
        },
        navigateToNewVehicle() {
            this.$router.push({ path: '/NewVehicle' });
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
    },
}
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

</style>